loadScript.$inject = ['$document', '$q'];

function loadScript($document, $q) {

  var scriptPromise = {};

  var load = function(src) {
    var script = $document[0].createElement('script');
    var deferred = $q.defer();

    script.onload = function() {
      scriptPromise[src] = $q.when();
      deferred.resolve();
    };

    script.onerror = function(error) {
      scriptPromise[src] = null;
      deferred.reject(error);
    };

    scriptPromise[src] = deferred.promise;

    script.charset = 'utf-8';
    script.async = true;
    script.src = src;

    $document[0].head.appendChild(script);
  };

  this.load = function(src) {
    if (! scriptPromise[src]) {
      load(src);
    }

    return scriptPromise[src];
  };

  this.loadAll = function(scripts) {
    return $q.all(
      scripts.map(function(src) {
        return this.load(src);
      }, this)
    );
  };

}

module.exports = loadScript;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/services/loadScript.js
 ** module id = 200
 ** module chunks = 1
 **/